import { useLayoutEffect } from 'react'
import { v4 } from 'uuid'
import { insertImage } from '../elements/image/Modal/ModalComponent'
import { isPlainObject } from 'lodash'

function useRTEEmbedListeners({ editor }) {
  useLayoutEffect(() => {
    if (!editor || !editor.useV2EmbedPicker) return
    editor.showImageEmbedModal = () => {
      const uuid = v4()
      const data = {
        uuid,
        allowOnlyImages: true,
        allowMultipleImageSelect: false
      }

      window.dispatchEvent(new CustomEvent('showAssetEmbedModal', { detail: data }))

      window.addEventListener(
        `${uuid}-assetEmbed`,
        (e: CustomEvent) => {
          const { asset } = e.detail
          if (!asset || !isPlainObject(asset) || !asset.url) return
          const state = new editor.TextareaState(editor.panels)
          insertImage({ url: asset.url, editor, state })
        },
        { once: true }
      )
    }
  }, [editor])
}

export default useRTEEmbedListeners
